import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/**
 * Blue preset configuration
 * Uses blue palette matching mockup Tailwind CSS colors
 * Primary: rgba(4, 92, 199, 1.00) - blue-600
 * Secondary/Ring: rgba(9, 121, 253, 1.00) - blue-500
 * Based on PrimeNG Theming documentation and mockup theme-variables.scss
 */
export const BluePreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}'
        },
        colorScheme: {
            light: {
                primary: {
                    // rgba(4, 92, 199, 1.00) - blue-600 from mockup
                    color: '{blue.600}',
                    inverseColor: '#ffffff',
                    hoverColor: '{blue.700}',
                    activeColor: '{blue.800}'
                },
                highlight: {
                    background: '{blue.600}',
                    focusBackground: '{blue.700}',
                    color: '#ffffff',
                    focusColor: '#ffffff'
                }
            },
            dark: {
                primary: {
                    // rgba(9, 121, 253, 1.00) - blue-500 from mockup dark mode
                    color: '{blue.500}',
                    inverseColor: '#ffffff',
                    hoverColor: '{blue.400}',
                    activeColor: '{blue.300}'
                },
                highlight: {
                    background: 'rgba(9, 121, 253, 0.16)',
                    focusBackground: 'rgba(9, 121, 253, 0.24)',
                    color: 'rgba(255,255,255,.87)',
                    focusColor: 'rgba(255,255,255,.87)'
                }
            }
        }
    },
    // Override button design tokens để button sm có kích thước nhỏ hơn theo Tailwind
    // Tailwind sm: h-7 (1.75rem), px-3 (0.75rem), py-2 (0.5rem)
    // Theo PrimeNG v20 design tokens: button.root.sm.*
    components: {
        button: {
            root: {
                sm: {
                    fontSize: '0.875rem', // text-sm = 14px
                    paddingX: '0.75rem', // px-3 = 12px
                    paddingY: '0.5rem' // py-2 = 8px
                }
            }
        }
    }
});

